import { DataGridColumn } from '@/components/DataGrid/DataGridColumn.class';
import { DataGridColumnType } from '@/components/DataGrid/DataGridColumnType.class';
import { Trip } from '@/typing/api/tripNew.class';
import { DataGridErrorType } from '@/typing/enums/dataGridErrorType.enum';
import { isUndefined } from '../isUndefined';

const isSameDateAsPreviousTimeValidator = (
    val: string,
    item: Trip,
    column: DataGridColumn,
    columns: DataGridColumn[]
) => {
    if (isUndefined(val)) {
        return { hasError: false };
    }

    const dateColumns = columns.filter(
        x => x.additionalInputType === DataGridColumnType.TimeDate
    );
    const currentColumnIndex = dateColumns.findIndex(
        x => x.valueKey === column.valueKey
    );

    if (currentColumnIndex === 0) {
        return { hasError: false };
    } else {
        const prevColumnKey: any =
            dateColumns[currentColumnIndex - 1].dateValueKey;
        const currentColumnKey: any =
            dateColumns[currentColumnIndex].dateValueKey;
        const obj: any = item;
        const isSameDate = obj[prevColumnKey] === obj[currentColumnKey];

        return {
            hasError: !isSameDate,
            errorType: DataGridErrorType.Warning,
            message: `Dit veld bevat een nieuwe datum (${obj[currentColumnKey]})`,
        };
    }
};

export default isSameDateAsPreviousTimeValidator;
